import { markCleanExit } from './crashReport';

/**
 * Перезагрузить ТОТ ЖЕ адрес. Отдельной функцией — чтобы проверка могла убедиться,
 * что экран ошибки перезагружает страницу, а не уводит на главную
 * (`components/layout/routeErrorScreen.test.ts`).
 *
 * Перезагрузка намеренная — флаг запуска помечается чистым, иначе следующий старт
 * принял бы её за падение (T23, `lib/crashReport.ts`).
 */
export function reloadPage(): void {
  markCleanExit();
  window.location.reload();
}
